import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.factoringError"],
  error => error
);
